import { Promotion } from "@lemmonhq/types";
import { getAPIClient } from "../helpers";
export const promotionsAPI = {
  getPromotions: async () => {
    const hc = getAPIClient();
    const resp = await hc.api.v2.promotions.$get();
    if (resp.ok) {
      const json = await resp.json();
      return json;
    } else {
      throw new Error(`unable to load promotions ${resp.status}`);
    }
  },
  createPromotion: async (
    json: Omit<Promotion, "id" | "created_at" | "updated_at">,
  ): Promise<Promotion> => {
    const hc = getAPIClient();
    const resp = await hc.api.v2.promotions.$post({
      json: json,
    });
    if (resp.ok) {
      const json = await resp.json();
      return json as unknown as Promotion;
    } else {
      throw new Error(`unable to create promotions ${resp.status}`);
    }
  },
  updatePromotion: async (json: Partial<Promotion> & { id: string }) => {
    const hc = getAPIClient();
    // todo: see why this needs a typecast
    const resp = await hc.api.v2.promotions[":id"].$put({
      json: json,
      param: { id: json.id },
    } as any);
    if (resp.ok) {
      const json = await resp.json();
      return json;
    } else {
      throw new Error(`unable to create promotions ${resp.status}`);
    }
  },
  deletePromotion: async (json: Promotion) => {
    const hc = getAPIClient();
    const resp = await hc.api.v2.promotions[":id"].$delete({
      param: { id: json.id },
    });
    if (resp.ok) {
      const json = await resp.json();
      return json;
    } else {
      throw new Error(`unable to create promotions ${resp.status}`);
    }
  },
};
